import { IDocumentState } from "./document-state.store";
import { GetterTree } from "vuex";
import { IRootState } from "../root-state.store";
import { IDocument } from "../../models/documents/document";

export const getters: GetterTree<IDocumentState, IRootState> = {
  document: (state: IDocumentState) => state.document,
  documents: (state: IDocumentState) => {
    return state.documents
  },
  sidebarDocuments: (state: IDocumentState) => {
    return state.sidebarDocuments
  },
  documentTypes: (state: IDocumentState) => {
    return state.documentTypes
  },
  activityStatus: (state: IDocumentState) => {
    return state.activityStatus
  },
  documentCrudActionStatus: (state: IDocumentState) => state.crudActionStatus,
  documentParameter: (state: IDocumentState) => state.documentParameter,
  paginationTotal: (state: IDocumentState) : number => state.pagination.total_pages,
  paginationPage: (state: IDocumentState) : number => state.pagination.page,
  pagination: (state: IDocumentState) => state.pagination,
  documentSelection: (state: IDocumentState) => state.documentSelection,
  loaders: (state:IDocumentState) => state.loaders,
  service: (state: IDocumentState) => state.service
}


// WEBPACK FOOTER //
// ./src/store/document/document-getters.store.ts